import {
  isEmpty,
  onlySpaces,
  isEmptyObject,
} from "../../utils/validators/validators";

export const getElementAttribute = (el, type) => el.getAttribute(type);

const Form = ({ children, setError, submitHandler, values }) => {
  const handleFormSubmit = (e) => {
    e.preventDefault();
    let errors = {};
    let inputFields = e.target.querySelectorAll("input");
    // Text field validation
    inputFields.forEach((input) => {
      let validate = getElementAttribute(input, "validate");
      if (validate !== "false") {
        // validate whitspaces and empty inputs
        if (onlySpaces(values[input.name]) || isEmpty(values[input.name])) {
          errors[input.name] = `Please enter ${getElementAttribute(
            input,
            "textname"
          )}`;
          // validate min_length and max_length characters
        } else if (
          input.getAttribute("min_length") ||
          getElementAttribute(input, "max_length")
        ) {
          let min = input.getAttribute("min_length");
          let max = getElementAttribute(input, "max_length");
          if (values[input.name].length < parseInt(min)) {
            errors[input.name] = `The ${getElementAttribute(
              input,
              "textname"
            )} must be at least ${min} characters.`;
          }
          if (values[input.name].length > parseInt(max)) {
            errors[input.name] = `The ${getElementAttribute(
              input,
              "textname"
            )} must not be greater than ${max} characters.`;
          }
        }
        let inputName = input.getAttribute("name");
        // Check date difference
        if (inputName == "start_date" || inputName == "end_start") {
          let start_date = values.start_date;
          let end_date = values.end_date;
          // let date_1 = new Date(start_date)
          // let date_2 = new Date(end_date)
          // const check = date_1.getDate() >= date_2.getDate()
          const check =
            start_date.split("-").join("") >= end_date.split("-").join("");
          if (check) {
            errors[
              input.name
            ] = `Start date can not be greater than or equal to end date`;
          }
        }

        // Checkbox Validation
        let type = input.getAttribute("type");
        if (type == "checkbox") {
          if (!input.value) {
            errors[input.name] = `Please select ${getElementAttribute(
              input,
              "textname"
            )}`;
          }
        }
        // if(type === 'file'){
        //     if(isEmptyObject(values[[input.name][0]])){
        //         errors[[input.name][0]] = 'Please choose file'
        //     }
        // }
      }
    });

    // Select field validation
    if (e.target.querySelectorAll("select")) {
      let selectFields = e.target.querySelectorAll("select");
      selectFields.forEach((select) => {
        let validate = getElementAttribute(select, "validate");
        if (validate !== "false") {
          if (onlySpaces(values[select.name]) || isEmpty(values[select.name])) {
            errors[select.name] = `Please choose ${getElementAttribute(
              select,
              "textname"
            )}`;
          }
        }
      });
    }

    // Text area validation
    if (e.target.querySelectorAll("textarea")) {
      let textFields = e.target
        .querySelectorAll("textarea")
        .forEach((textarea) => {
          let validate = getElementAttribute(textarea, "validate");
          if (!validate) {
            if (
              onlySpaces(values[textarea.name]) ||
              isEmpty(values[textarea.name])
            ) {
              errors[textarea.name] = `Please enter ${getElementAttribute(
                textarea,
                "textname"
              )}`;
            } else if (
              textarea.getAttribute("min_length") ||
              getElementAttribute(textarea, "max_length")
            ) {
              let min = textarea.getAttribute("min_length");
              let max = getElementAttribute(textarea, "max_length");
              if (values[textarea.name].length < parseInt(min)) {
                errors[textarea.name] = `The ${getElementAttribute(
                  textarea,
                  "textname"
                )} must be at least ${min} characters.`;
              }
              if (values[textarea.name].length > parseInt(max)) {
                errors[textarea.name] = `The ${getElementAttribute(
                  textarea,
                  "textname"
                )} must not be greater than ${max} characters.`;
              }
            }
          }
        });
    }

    if (!isEmptyObject(errors)) {
      setError(errors);
    } else {
      submitHandler();
    }
  };

  return (
    <>
      <form action='POST' onSubmit={handleFormSubmit}>
        {children}
      </form>
    </>
  );
};

export default Form;
